import { Link } from 'react-router-dom'
import { TrendingUp } from 'lucide-react'
import { EmptyState, Skeleton } from '@teach/ui'
import { useGetCreditsUsageQuery } from '@/features/ai/creditsApi'
import { hasUsage, usageBars } from '@/features/ai/lib/usageBars'
import { useMessages } from '@/i18n'
import { messages } from './messages'
import { UsageChart } from './UsageChart'

/** Ниже стандартной `card`-пустоты: карточка стоит в ряд с балансом и не должна его вытягивать. */
const COMPACT = 'min-h-32 [&>div]:ml-40 [&>img]:w-32'
const DAYS = 30
/** Сутки режутся по поясу браузера — иначе трата в час ночи попала бы во вчерашний столбик. */
const timeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone

/** Траты кредитов по дням за месяц; подробный список — на «Использовании». */
export const RecentUsageCard = () => {
  const m = useMessages(messages)
  const { data, isLoading, isError } = useGetCreditsUsageQuery({ days: DAYS, tz: timeZone() })
  const bars = data ? usageBars(data) : []

  return (
    <div className="relative flex min-h-[168px] flex-col overflow-hidden rounded-2xl bg-foreground/5">
      <div className="mb-2 flex items-center justify-between gap-3 whitespace-nowrap px-5 pt-5 text-sm">
        <span className="flex items-center gap-2 text-muted-foreground">
          <TrendingUp className="size-4" />
          {m.spendingHistory}
        </span>
        <Link
          to="/settings/balance"
          className="text-muted-foreground underline decoration-foreground/20 underline-offset-4 transition-colors hover:text-foreground hover:decoration-foreground/50"
        >
          {m.seeAll}
        </Link>
      </div>
      {isLoading ? (
        <div className="px-5 pb-5">
          <Skeleton className="h-24 w-full" />
        </div>
      ) : isError ? (
        <EmptyState size="card" title={m.historyLoadFailed} className={COMPACT} />
      ) : hasUsage(bars) ? (
        <UsageChart bars={bars} />
      ) : (
        <EmptyState size="card" title={m.nothingHere} className={COMPACT} />
      )}
    </div>
  )
}
